import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

// Ngx-lottie (Animaciones)
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

// Ngx-toastr (Alertas)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

// Firebase Imports
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
// Firebase Configuration
import { environment } from 'src/environments/environment';

import { HeaderComponent } from './components/header/header.component';
import { InicioPageComponent } from './pages/inicio-page/inicio-page.component';
import { WavesComponent } from './components/waves/waves.component';
import { MenuPageComponent } from './pages/menu-page/menu-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { RegisterPageComponent } from './pages/register-page/register-page.component';
import { LoaderComponent } from './components/loader/loader.component';
import { QuinielasPageComponent } from './pages/admin/quinielas-page/quinielas-page.component';
import { QuinielaPageComponent } from './pages/admin/quiniela-page/quiniela-page.component';
import { JugadoresPageComponent } from './pages/admin/jugadores-page/jugadores-page.component';
import { CompartirPageComponent } from './pages/admin/compartir-page/compartir-page.component';
import { JugadorPageComponent } from './pages/jugador-page/jugador-page.component';
import { LlenadoPageComponent } from './pages/llenado-page/llenado-page.component';
import { TablaPageComponent } from './pages/tabla-page/tabla-page.component';
import { MostrarQuinielaComponent } from './pages/mostrar-quiniela/mostrar-quiniela.component';
import { PartidoPageComponent } from './pages/partido-page/partido-page.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { FAQPageComponent } from './pages/faqpage/faqpage.component';
import { EliminarQuinielaPageComponent } from './pages/admin/eliminar-quiniela-page/eliminar-quiniela-page.component';
import { PagoPageComponent } from './pages/pago-page/pago-page.component';
import { HeaderSimpleComponent } from './components/header-simple/header-simple.component';
import { AdminPageComponent } from './pages/admin/admin-page/admin-page.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    InicioPageComponent,
    WavesComponent,
    MenuPageComponent,
    LoginPageComponent,
    RegisterPageComponent,
    LoaderComponent,
    QuinielasPageComponent,
    QuinielaPageComponent,
    JugadoresPageComponent,
    CompartirPageComponent,
    JugadorPageComponent,
    LlenadoPageComponent,
    TablaPageComponent,
    MostrarQuinielaComponent,
    PartidoPageComponent,
    ReportPageComponent,
    FAQPageComponent,
    EliminarQuinielaPageComponent,
    PagoPageComponent,
    HeaderSimpleComponent,
    AdminPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    HttpClientModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    LottieModule.forRoot({ player: playerFactory }), NgbModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
